import getBlock from './block';
import constraints from '../../constraints';

const getBlockConstraint = (rootState, blockId) => {
  const block = getBlock(rootState, blockId);

  if (!block || !block.constraintId) {
    return null;
  }

  const templateConstraints = constraints.selectors.getConstraints(rootState);

  return templateConstraints.find((constraint) => constraint.id === block.constraintId) || null;
};

export default getBlockConstraint;
